//#region src/common/open-window-safely.ts
var e = (e = "", t = "_blank", n) => {
	let r = window.open(e, t, n);
	return {
		navigate: (e) => {
			r ? r.location.href = e : window.open(e, t, n);
		},
		close: () => {
			r && r.close();
		},
		window: r
	};
};
//#endregion
export { e as openWindowSafely };
